/**
 * SidebarFooter - Reusable footer component for sidebars
 * Displays app info, version, and optional custom content
 */
export default function SidebarFooter({
  primaryText = 'Admin Access Required',
  secondaryText = 'v1.0.0',
  isCollapsed = false,
  className = ''
}) {
  if (isCollapsed) {
    return null;
  }

  return (
    <div className={`p-4 border-t border-gray-700 flex-shrink-0 overflow-hidden ${className}`}>
      <div className="text-xs space-y-1" style={{ color: 'var(--color-text-muted)' }}>
        <div>{primaryText}</div>
        {secondaryText && <div style={{ color: 'var(--color-text-disabled)' }}>{secondaryText}</div>}
      </div>
    </div>
  );
}
